module.exports = __webpack_public_path__ + "static/media/logout.07831219.svg";